<template>
  <div id="articles">
    <!-- header part -->
    <my-header2></my-header2>
    <!-- article mian part -->
    <div id="article-main">
      <div class="container">
        <!-- catalog left and right part -->
        <div class="row p-3">

          <!-- catalgo right -->
          <div class="col-sm-6 col-lg-9 bg-white">
            <!-- breadcrumb part -->
            <ol class="breadcrumb bg-white">
              <li class="breadcrumb-item"><a href="/">首页</a></li>
              <li class="breadcrumb-item">学校概况</li>
              <li class="breadcrumb-item active" aria-current="page">学校简介</li>
            </ol>
            <!-- details content part -->
            <section>
              <div class="details-content py-5" v-html="intro"></div>
            </section>
            <!-- prev and next part -->
            <div class="prev-next text-right p-3">
              <a href="javascript:window.print();">[ 打印本页 ]</a>
            </div>
          </div>

          <!-- catalog left -->
          <div class="col-sm-6 col-lg-3 d-none d-md-block" id="catalog-left">
            <h4 class="m-0 p-3 text-center text-white catalog-hd">学校简介</h4>
            <p class="m-0"><img src="/static/img/catalog/catalog-banner.png" width="100%"></p>
            <my-sidebar></my-sidebar>
          </div>

        </div>
      </div>
    </div>
    <!-- footer part -->
    <my-footer></my-footer>
  </div>
</template>
<script>


import header from '@/views/header/header';
import footer from '@/views/footer/footer';
import header2 from '@/views/header/header2';
import sidebar from '@/views/sidebar/sidebar';

const axios = require('axios');

export default {
  name: 'articles',
  components: {
    'my-header': header,
    'my-footer': footer,
    'my-header2': header2,
    'my-sidebar': sidebar
  },
  data() {
    return {
      // 父栏目
      parentChannel: {'name':''},
      // 左侧子栏目
      childrens: [{'name':''}],
      // 当前点击栏目
      currChannel: {'name':''},
      artId : null,
      intro: "",
      categoryUrl: '/article/category/'
    }
  },
  created() {
    const artId = this.$route.params.artId;
    this.artId = artId;
  },
  mounted () {
    let that = this;
    // 加载文章
    that.init();

  },
  methods:{
    // 加载文章
    init: function () {
      var that = this;
      // 获取简介
      axios.get(that.global.apiUrl + '/web/site/queryAll')
        .then(function (response) {
          if (response.data.success && response.data.data.length > 0) {
            var str = response.data.data[0].intro
            str = str.replace(/api\/file/g,that.global.apiUrl+'/file')
            that.intro = str
          }else if (response.data.success && response.data.data.length == 0) {
            that.intro = "暂无简介"
          }else {
            that.$router.push({ name: 'page404'});
          }
        });
    },
    getPartTimeForDate:function (val) {
      var timearr = val.replace(" ", ":").replace(/\:/g, "-").split("-");
      var timestr = ""+ Number(timearr[1])+ "月" + timearr[2]+"日";
      return timestr;
    },
    getPartTimeYmd: function (val) {
      //let ti = val.split(' ');
      var timearr = val.split(" ");
      var timestr = ""+ timearr[0];
      return timestr;
    }
  }
};

// $(document).ready(function() { });



</script>

<style>
  #article-main {
    background-color: #ecf2f6;
  }
  .catalog-hd {
    /* background-color: #8B0000; */
    /* background-color: #2092c8; */
     /* background-image: radial-gradient(circle, #104883, #022952); */
     background-color: #0050a5!important;
  }
  #catalog-left h4 {
    font-size: 1.2rem;
  }
  .catalog-list-group {
    border-top: 0!important;
    border-radius: 0;
  }
  .catalog-list-group li:hover {
    /* background-color: #8B0000; */
    background-color: #0069D9;
    /* background-color: #0050a5; */
    color: #FFFFFF;
  }
  .catalog-list-group li:hover a {
    color: #FFFFFF;
    text-decoration: none;
  }
  .liactive {
      z-index: 2;
      color: #FFFFFF!important;
      /* background-color: #8B0000!important; */
      background-color: #0050a5!important;
      /* border-color: #8B0000!important; */
      /* border-color: #0050a5!important; */
      /* background-image: radial-gradient(circle, #104883, #022952); */
      border-color: #104883!important;
  }
  .liactive a {
    color: #FFFFFF;
  }

  .breadcrumb {
    /* background-color: #FFFFFF; */
    font-size: 14px;
    border-bottom: 1px #ccc solid;
    border-radius: 0;
  }
  .details-title {
    font-size: 18px;
    font-weight: bold;
  }
  .details-intro {
    font-size: 12px;
    border-bottom: 1px #ccc dotted;
  }
  .details-content {
    border-bottom: 1px #ccc dotted;
  }
  .details-content img {
    max-width: 100%!important;
  }
  .prev-next {
    font-size: 12px;
    color: #333333;
  }
</style>



// WEBPACK FOOTER //
// src/views/intro/intro.vue